import styled from "styled-components"

export const FormulationsContainer = styled.div`
  padding: 40px 0;

  h2 {
    color: ${props => props.theme.colors.darkBlue};
    margin-bottom: 10px;
  }

  h5 {
    font-weight: 300;
    color: ${props => props.theme.colors.brightBlue};
  }

  .compounds {
    margin: 30px 0;
    display: flex;
    @media (max-width: 768px) {
      flex-direction: column;
    }
    .compound {
      display: flex;
      align-items: center;
      margin-right: 24px;
      .circle {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        margin-right: 10px;
      }
      .blue1 {
        background-color: #00aeef;
      }
      .blue2 {
        background-color: #79add3;
      }
      .blue3 {
        background-color: #017cba;
      }
      .blue4 {
        background-color: #00416b;
      }
      @media (max-width: 768px) {
        margin: 8px 0;
      }
      .compound:first-child {
        margin-top: 0;
      }
    }
  }

  .formulations {
    margin-top: 80px;
    .formulation {
      margin-bottom: 60px;
      h3 {
        font-weight: 600;
        color: ${props => props.theme.colors.darkBlue};
        margin-bottom: 12px;
      }
      p {
        color: #979797;
        margin-bottom: 8px;
      }
      .img-container {
        margin: 0 auto;
        max-width: 500px;
      }
      button {
        border: none;
        background-color: transparent;
        display: block;
        margin-top: 12px;
        font-weight: 400;
        padding: 0;
        color: ${props => props.theme.colors.darkBlue};
        &:hover {
          cursor: pointer;
        }
      }
    }

    .row {
      margin-bottom: 30px;
      button {
        border: none;
        background-color: transparent;
        display: block;
        margin-top: 12px;
        font-weight: 400;
        color: ${props => props.theme.colors.darkBlue};
        &:hover {
          cursor: pointer;
        }
      }
      .text {
        display: flex;
        flex-direction: column;
        justify-content: center;
        h5 {
          font-weight: 600;
          color: ${props => props.theme.colors.darkBlue};
          margin-bottom: 12px;
        }
        p {
          color: #979797;
          margin-bottom: 8px;
        }
      }
    }
    .right-img-row {
      .text {
        h5 {
          text-align: right;
        }
        @media (max-width: 768px) {
          order: 2;
          h5 {
            text-align: left;
          }
        }
      }
    }
  }
`

export const Wrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
`
